<script>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import exclamation from '../design-system/icon/exclamation.vue';
import DesignButton from '../design-system/design-button.vue';

export default {
    components: {
        Dialog,
        DialogPanel,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        DesignButton,
        exclamation
    },
    props: {
        modelValue: Boolean,
        modalTitle: String,
        modalContent: String,
        buttonText: String,
        buttonColor: String,
        divClassFlex: Boolean,
        hasAlertIcon: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'afterClick'],
    data() {
        return {};
    },
    methods: {
        clickCancelButton() {
            const self = this;
            self.$emit('update:modelValue', false);
        },
    },
};
</script>

<template>
    <TransitionRoot as="template" :show="modelValue">
        <Dialog as="div" class="relative z-[80]" @close="$emit('update:modelValue', false)">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-transparent-basic-3 transition-opacity" />
            </TransitionChild>

            <div class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative bg-white rounded-4 w-[300px] p-4 pb-5 overflow-hidden shadow-modal transform transition-all flex flex-col items-center">
                            <div :class="[divClassFlex ? 'sm:flex sm:items-start' : 'sm:flex-1 sm:items-start']">
                                <div v-if="hasAlertIcon" class="mx-auto flex-shrink-0 flex items-center justify-center h-8 w-8 pt-2">
                                    <exclamation class="text-accent-red-3"/>
                                </div>
                                <div class="text-center">
                                    <DialogTitle as="h3" class="font-body-md-medium whitespace-pre-line"> {{ modalTitle }} </DialogTitle>
                                    <div class="mt-2">
                                        <p class="font-body-sm-regular text-content-basic-2">{{ modalContent }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4 flex justify-center gap-2 w-full">
                                <DesignButton btnType="SECONDARY" btnVariant="BORDER" btnText="Cancel" btnSize="MD" class="w-full" @click-event="clickCancelButton"/>
                                <DesignButton :btnType="buttonColor" btnVariant="FILL" :btnText="buttonText" btnSize="MD" class="w-full" @click-event="$emit('afterClick')"/>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
